import React from 'react';
import MarcadorPadel from './components/MarcadorPadel';
import './index.css';

function App() {
  return (
    <div className="App">
      <MarcadorPadel />
    </div>
  );
}

export default App;
